import { ComponentRef, Injectable } from '@angular/core';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { take } from 'rxjs/operators';
import { FormControl, ValidationErrors, Validators } from '@angular/forms';
import { GlobalService } from '../services/global.service';
import { VideoLayerComponent } from '../components/video-layer/video-layer.component';
import { NotificationComponent } from '../components/notification/notification.component';

@Injectable({
    providedIn: 'root'
})
export class CommonUtil {

    phoneMask: any = {
        mask: [
            /[0-9]/,
            /[0-9]/,
            ' ',
            /[0-9]/,
            /[0-9]/,
            /[0-9]/,
            /[0-9]/,
            ' ',
            /[0-9]/,
            /[0-9]/,
            /[0-9]/,
            /[0-9]/,
        ],
        guide: true,
    };

    constructor(
        private overlay: Overlay,
        private globalService: GlobalService
    ) { }


    pageScrollToTop() {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }


    openVideoOverlay(videoId: string, videoURL: string = '') {
        let videoLayoutOverlay: any = OverlayRef;
        videoLayoutOverlay = this.overlay.create({
            hasBackdrop: true,
            scrollStrategy: this.overlay.scrollStrategies.noop(),
            backdropClass: 'primary-backdrop',
            panelClass: 'full-overlay-panel',
        });
        const videoLayerPortal = new ComponentPortal(VideoLayerComponent);
        let ref: any = ComponentRef<VideoLayerComponent>;
        ref = videoLayoutOverlay.attach(videoLayerPortal);
        ref.instance.videoId = videoId;
        ref.instance.videoURL = videoURL;
        ref.instance.closeLayer
            .pipe(take(1))
            .subscribe(() => videoLayoutOverlay.dispose());
    }
    openSelectedAdNotification(
        type: string, message?: string, mainBtnContent?: string, imgSrc?: string, subMessage?: string, secondBtnContent?: string
    ) {
        this.globalService.selectedAdNotificationOpened = true;
        let videoLayoutOverlay:any= OverlayRef;
        videoLayoutOverlay = this.overlay.create({
            hasBackdrop: false,
            scrollStrategy: this.overlay.scrollStrategies.noop(),
            panelClass: 'selected-ad-notification',
        });
        const notificationPortal = new ComponentPortal(NotificationComponent);
        let ref:any= ComponentRef<NotificationComponent>;
        ref = videoLayoutOverlay.attach(notificationPortal);
        ref.instance.type = type;
        ref.instance.message = message;
        ref.instance.mainBtnContent = mainBtnContent;
        ref.instance.imgSrc = imgSrc;
        ref.instance.subMessage = subMessage;
        ref.instance.secondBtnContent = secondBtnContent;
        ref.instance.closeLayer.pipe(take(1)).subscribe(() => {
            videoLayoutOverlay.dispose();
            this.globalService.selectedAdNotificationOpened = false;
        });
    }
}
